import React, { createContext, useContext, useEffect, useRef, useState } from "react";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import Sidebar from "../Sidebar";
import { PageContext } from "~/App";
import { capitalizeFirstLetter, getFinalRouteName } from "~/functions";
import { useSelector } from "react-redux";

export const FullGridContext = createContext();

export default function Commercial() {
  const { pages } = useContext(PageContext);
  const { pathname } = useLocation();
  const { accesses } = useSelector((state) => state.auth);
  const accessModule = accesses.hierarchy.find(
    (el) => el.alias === "commercial"
  );
  const navigate = useNavigate();
  const [activeFilters, setActiveFilters] = useState([]);
  const [opened, setOpened] = useState(false);
  const [orderBy, setOrderBy] = useState(null);
  const [gridHeader, setGridHeader] = useState([]);
  const [gridData, setGridData] = useState([]);
  const [loadingData, setLoadingData] = useState(true);
  const [successfullyUpdated, setSuccessfullyUpdated] = useState(true);
  const [page, setPage] = useState(1);
  const [pagesNo, setPages] = useState(1);
  const [limit, setLimit] = useState(50);
  const [search, setSearch] = useState("");
  const [gridDetails, setGridDetails] = useState({
    totalRows: 0,
    pages: 1,
  });
  const delayDebounceFn = useRef(null);
  const paths = pathname.split("/");
  const routeName = capitalizeFirstLetter(paths[1]);
  const modulePages =
    pages?.find((page) => page.name === routeName)?.children ?? [];
  const finalRouteName = getFinalRouteName(
    accesses,
    pathname,
    "commercial",
    "commercial-dashboard",
    modulePages
  );

  function handleFilters({ title = "", value = "" }) {
    if (title === "search") {
      clearTimeout(delayDebounceFn.current);
      delayDebounceFn.current = setTimeout(() => {
        setActiveFilters([]);
        setPage(1);
        setSearch({ pathname, value });
      }, 700);

      return;
    } else {
      if (value === false || value) {
        setActiveFilters([
          ...activeFilters.filter((el) => el.title != title),
          { title, value },
        ]);
      } else {
        setActiveFilters([...activeFilters.filter((el) => el.title != title)]);
      }
    }
  }

  useEffect(() => () => clearTimeout(delayDebounceFn.current), []);

  function handleOpened(id) {
    if (!id) {
      setSuccessfullyUpdated(true);
    }
    setOpened(id);
  }

  useEffect(() => {
    if (!finalRouteName) {
      return;
    }
    if (
      pathname.toUpperCase() === `/${routeName}`.toUpperCase() ||
      pathname.toUpperCase() === `/${routeName}/`.toUpperCase()
    ) {
      navigate(`/${routeName}/${finalRouteName}`);
    }
  }, [pathname, finalRouteName]);

  return (
    <div className="w-full bg-linear-to-br from-gray-300 via-indigo-300 to-mila_orange flex flex-1 flex-row justify-between items-center px-4 pt-8 shadow-lg overflow-y-scroll">
      <Sidebar
        main={routeName.toLowerCase()}
        pages={pages && pages.find((page) => page.name === routeName).children}
      />

      <FullGridContext.Provider
        value={{
          accessModule,
          activeFilters,
          setActiveFilters,
          opened,
          setOpened,
          orderBy,
          setOrderBy,
          gridHeader,
          setGridHeader,
          gridData,
          setGridData,
          successfullyUpdated,
          setSuccessfullyUpdated,
          page,
          setPage,
          pages: pagesNo,
          setPages,
          limit,
          setLimit,
          search,
          setSearch,
          handleFilters,
          handleOpened,
          loadingData,
          setLoadingData,
          gridDetails,
          setGridDetails,
        }}
      >
        <Outlet />
      </FullGridContext.Provider>
    </div>
  );
}
